import axios from "axios";

const GetDivisions = async () => {
  return axios.get(`Division/GetDivisions`).then((response) => response);
};

const GetDivisionById = async (p_div_code) => {
  return axios
    .get(`Division/GetDivisionById`, { params: { p_div_code } })
    .then((response) => response);
};

const AddDivision = async (payload) => {
  // POST with query params (matches your documented example)
  return axios
    .post(`Division/AddDivision`, null, { params: payload })
    .then((response) => response);
};

const UpdateDivision = async (payload) => {
  return axios
    .post(`Division/UpdateDivision`, null, { params: payload })
    .then((response) => response);
};

const divisionService = {
  GetDivisions,
  GetDivisionById,
  AddDivision,
  UpdateDivision,
};

export default divisionService;